// extracted by mini-css-extract-plugin
export default {"root":"J2YyjLAJQR","root_largeRowGap":"FYEVbdvLKb"};